import {
  ApiCartDeleteCartEntryFailedAction,
  ApiCartDeleteCartEntrySucceededAction,
  apiCartDeleteCartEntryFailedType,
  apiCartDeleteCartEntryRequested,
  apiCartDeleteCartEntrySucceededType
} from '../../api/cart/deleteCartEntryApi';
import {
  DeleteCurrentCartEntryRequestedAction,
  deleteCurrentCartEntryFailed,
  deleteCurrentCartEntrySucceeded
} from '../../carts/cartsSlice';
import { put, race, select, take } from 'typed-redux-saga';
import convertCartToStateCart from '../../../converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';
import getCartCustomOrderTypeForEntries from '../../carts/getCartCustomOrderTypeForEntries';
import selectGeneralSettings from '../../settings/selectors/selectGeneralSettings';

function* deleteCurrentCartEntrySaga({
  payload: { actionId: requestedActionId, entryId, customOrderType }
}: DeleteCurrentCartEntryRequestedAction): Generator {
  const { checkoutDeliverySelectionEnabled } = yield* select(selectGeneralSettings);
  const actionId: number = generateActionId();

  yield* put(
    apiCartDeleteCartEntryRequested({
      actionId,
      customOrderType,
      entryId,
      parentActionId: requestedActionId
    })
  );

  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiCartDeleteCartEntrySucceededAction>(apiCartDeleteCartEntrySucceededType),
      failed: take<ApiCartDeleteCartEntryFailedAction>(apiCartDeleteCartEntryFailedType)
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        const resolvedCustomOrderType = checkoutDeliverySelectionEnabled
          ? getCartCustomOrderTypeForEntries(succeeded.payload.result.cart.entries)
          : customOrderType;
        yield* put(
          deleteCurrentCartEntrySucceeded({
            cart: convertCartToStateCart(succeeded.payload.result.cart),
            customOrderType: resolvedCustomOrderType,
            entryId,
            requestedActionId,
            sourceCustomOrderType: customOrderType
          })
        );
      } else if (failed !== undefined) {
        yield* put(
          deleteCurrentCartEntryFailed({
            requestedActionId
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default deleteCurrentCartEntrySaga;
